export default "__VITE_ASSET__CX4b7UM1__"